module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"country":"Country","date":"Registration date","email":"Email","role":"Role","type":"Registration type"}}')
  delete Component.options._Ctor
}
